export default "__VITE_ASSET__CZMAwG4J__"